import { Routes } from '@angular/router';
import { authGuard, roleGuard } from '../../guards/auth.guard';
import { UserRoles } from '@shared/models/user-roles';

export const ordersRoutes: Routes = [
  {
    path: 'orders',
    title: 'Aufträge Übersicht',
    loadComponent: () => import('./orders-list/orders-list').then(m => m.OrdersListComponent),
    canActivate: [authGuard],
  },
  {
    path: 'orders/new',
    title: 'Neuer Auftrag',
    loadComponent: () => import('./order-form/order-form').then(m => m.OrdersFormComponent),
    canActivate: [roleGuard],
    data: { roles: [UserRoles.ORDER_WRITE] },
  },
  {
    path: 'orders/details/:id',
    title: 'Auftrag Details',
    loadComponent: () => import('./order-detail/order-detail').then(m => m.OrderDetailComponent),
    canActivate: [authGuard],
  },
  {
    path: 'orders/:id/edit',
    title: 'Auftrag bearbeiten',
    loadComponent: () => import('./order-form/order-form').then(m => m.OrdersFormComponent),
    canActivate: [roleGuard],
    data: { roles: [UserRoles.ORDER_WRITE] },
  },
];
